var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon32Paperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1053 9.09174L10.2196 15.8606C9.45964 16.6076 8.22656 16.6076 7.4659 15.8606C6.70523 15.1128 6.70523 13.9007 7.4659 13.1529L14.3516 6.38408C15.8722 4.88857 18.3384 4.88857 19.859 6.38408C21.3803 7.87958 21.3803 10.3039 19.859 11.7987L12.974 18.5676C10.6927 20.8108 6.99279 20.8108 4.71149 18.5676C2.4295 16.325 2.4295 12.6885 4.71149 10.4452L12.2852 3",
    stroke: "#0A7E85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon32Paperclip);
export default __webpack_public_path__ + "static/media/icon32_paperclip.a136aced8331380efdc8e3242900df7c.svg";
export { ForwardRef as ReactComponent };